import styled from 'styled-components';

export const Desc = styled.div`

    @media(max-width: 600px) {
        margin-top: 80px;
  }
`;